import { z } from 'zod';
import { AttendanceStatusSchema, FeedbackCategorySchema, GradeSituationSchema } from './enums';
import { IdSchema, IsoDateSchema } from './validation';

export const ScoreSchema = z
  .number()
  .min(0, 'A nota mínima é 0')
  .max(10, 'A nota máxima é 10')
  .transform((v) => Math.round(v * 100) / 100);

export const UpsertGradesSchema = z.object({
  academicYearId: IdSchema,
  grades: z
    .array(
      z.object({
        termId: IdSchema,
        subjectId: IdSchema,
        /** null remove a nota. */
        score: ScoreSchema.nullable(),
      }),
    )
    .min(1)
    .max(200),
});
export type UpsertGradesInput = z.input<typeof UpsertGradesSchema>;

export const GradesQuerySchema = z.object({
  academicYearId: IdSchema.optional(),
});

export const ReportCardRowSchema = z.object({
  subjectId: z.string(),
  subjectName: z.string(),
  scores: z.record(z.string(), z.number().nullable()),
  average: z.number().nullable(),
  situation: GradeSituationSchema,
});
export type ReportCardRow = z.infer<typeof ReportCardRowSchema>;

export const ReportCardSchema = z.object({
  studentId: z.string(),
  academicYearId: z.string(),
  terms: z.array(z.object({ id: z.string(), name: z.string(), shortName: z.string(), number: z.number() })),
  rows: z.array(ReportCardRowSchema),
  overallAverage: z.number().nullable(),
  attendanceRate: z.number().nullable(),
  policy: z.object({ passingScore: z.number(), recoveryMinScore: z.number() }),
});
export type ReportCard = z.infer<typeof ReportCardSchema>;

export const CreateFeedbackSchema = z.object({
  title: z.string().trim().min(3, 'Informe um título').max(120),
  content: z.string().trim().min(5, 'Descreva o feedback').max(2000),
  category: FeedbackCategorySchema.default('PEDAGOGICAL'),
  classId: IdSchema.optional(),
});
export type CreateFeedbackInput = z.input<typeof CreateFeedbackSchema>;

export const FeedbackSchema = z.object({
  id: z.string(),
  studentId: z.string(),
  classId: z.string().nullable(),
  title: z.string(),
  content: z.string(),
  category: FeedbackCategorySchema,
  author: z.object({ uid: z.string(), name: z.string() }),
  createdAt: z.string(),
});
export type Feedback = z.infer<typeof FeedbackSchema>;

export const AttendanceBatchSchema = z.object({
  classId: IdSchema,
  date: IsoDateSchema,
  records: z
    .array(z.object({ studentId: IdSchema, status: AttendanceStatusSchema }))
    .min(1)
    .max(80),
});
export type AttendanceBatchInput = z.infer<typeof AttendanceBatchSchema>;

export const AttendanceQuerySchema = z.object({
  classId: IdSchema,
  from: IsoDateSchema,
  to: IsoDateSchema,
});
export type AttendanceQuery = z.infer<typeof AttendanceQuerySchema>;

export const AttendanceRecordSchema = z.object({
  id: z.string(),
  studentId: z.string(),
  classId: z.string(),
  date: z.string(),
  status: AttendanceStatusSchema,
});
export type AttendanceRecord = z.infer<typeof AttendanceRecordSchema>;
